import type { FaireProductEntity } from "../../entity_types/product";

export const p_cv3c2ar52r: FaireProductEntity = {
  token: "p_cv3c2ar52r",
  type: "product",
  name: "LM-SK-1000 BUBBLE SKIRT - BLACK CAMO",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/e099cfa23143ca54d90608a2bbc7fab82a4c62c4740cdd8a614d528491d4dfc7.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.5,
  description: "This black camo bubble skirt from Girlie Girl Originals offers a playful silhouette with a bold edge. It pairs well with casual tops or layered looks and makes a distinctive addition to a stylish wardrobe.",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:35.011Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
